import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AsyncPipe, NgClass, NgForOf } from '@angular/common';
import { PricePipe } from '@lx/shared/ui/pipes';
import { Transfer } from '@lx/shared/data-access/products';
import { Observable } from 'rxjs';
import { QuoteToolLiteStore } from '../../store';

@Component({
  standalone: true,
  selector: 'lx-transfer-selector-options',
  templateUrl: './transfer-selector-options.component.html',
  styleUrls: ['./transfer-selector-options.component.scss'],
  imports: [NgClass, PricePipe, NgForOf, AsyncPipe],
})
export class TransferSelectorOptionsComponent {
  @Input() transfers: Transfer[] | undefined;
  @Input()
  get selectedTransferRow(): number | undefined {
    return this._selectedTransferRow;
  }

  set selectedTransferRow(selectedTransferRow: number) {
    this._selectedTransferRow = selectedTransferRow;
  }

  @Output() selectedTransferRowChange = new EventEmitter<number>();
  @Output() cleanSelectedTransferRow = new EventEmitter<number>();

  currency$: Observable<string> | undefined;

  private _selectedTransferRow: number | undefined;

  private readonly qtLiteStore = inject(QuoteToolLiteStore);

  constructor() {
    this.currency$ = this.qtLiteStore.selectedCurrency$;
  }

  setSelectedTransferRow(transferRow: number) {
    this.selectedTransferRowChange.emit(transferRow);
  }

  removeSelectedTransferRow() {
    this.cleanSelectedTransferRow.emit(this.selectedTransferRow);
  }

  protected handleKeySelection(event: KeyboardEvent, transferRow: number) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.setSelectedTransferRow(transferRow);
    }
  }

  protected handleKeyDeselection(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.removeSelectedTransferRow();
    }
  }
}
